import { Primitive } from '../../../types/blocks/Primitive';

const IconBlock: Primitive = {
  name: 'IconBlock',
  friendlyName: 'Icon',
  isInput: false,
  isPrimitive: true,
  isAvailableInEditor: true,
  tags: ['Media'],
  properties: {
    icon: {
      type: 'Icon',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default IconBlock;
